<template>
  <div class="enterprise-list-page enterprise-list-page--bed-allotment">
    <!-- Header Card -->
        <PageHeader icon="fas fa-procedures">
      <template #title>
        Daftar Bed yang Ditempati
      </template>
      <template #subtitle>
        Tinjau daftar pasien rawat inap dan pemakaian bed aktif
      </template>
      <template #actions>
        <b-button
                class="btn btn-primary font-weight-bold px-6 hc-btn-tambah-jadwal"
                v-if="manipulateBtn == true"
                @click="$router.push('/beds/add-allotment')">
                <i class="fas fa-plus"></i>
                <span>Tambah Alokasi</span>
              </b-button>
      </template>
    </PageHeader>

    <div class="row">
      <div class="col-md-12">
        <Card>
          <template v-slot:body>
            <modern-filter-bar
              embedded
              single-line
              inline-period
              :show-timeseries="false"
              :search-text.sync="filter.patient_name"
              :show-period="true"
              :start-date.sync="filter.start_date"
              :end-date.sync="filter.end_date"
              search-placeholder="Cari nama pasien"
              @search-keyup="filterByPatientName"
              @period-search="filterByPeriode"
              @period-reset="resetFilterPeriode"
            />

            <medhop-data-table summary-title="Pemakaian Bed" striped hover class="mt-3" :items="items" :fields="fields" responsive>
              <template #cell(allotedTime)="data">
                {{ handleDate(data.item.date_in) }}
              </template>
              <template #cell(dischargeTime)="data">
                {{ handleDate(data.item.date_out) }}
              </template>
              <template #cell(actions)="data">
                <div v-if="data.item.is_used == 1">
                  <b-button
                    size="sm"
                    class="mr-1 btn-danger mb-1"
                    v-if="usedBtn == true"
                    v-b-tooltip.hover
                    title="Kosongkan bed"
                    @click="handleEdit(data.item.id)"><i class="fas fa-sign-out-alt px-0"></i></b-button>
                </div>
                <div v-if="data.item.is_used == 0">
                  <b-button
                    size="sm"
                    class="mr-1 btn-primary mb-1"
                    v-b-tooltip.hover
                    title="Selesai"><i class="fas fa-check-square"></i></b-button>
                </div>
                <b-button
                  size="sm"
                  class="mr-1 btn-success"
                  v-b-tooltip.hover
                  title="Ubah"
                  v-if="manipulateBtn == true"
                  @click="
                    $router.push({
                      path: '/beds/edit-allotment/' + data.item.id,
                    })
                  ">
                  <i class="fas fa-edit px-0"></i>
                </b-button>
                <b-button
                  size="sm"
                  class="btn-danger"
                  v-b-tooltip.hover
                  title="Hapus"
                  v-if="manipulateBtn == true"
                  @click="handleDelete(data.item.id)">
                  <i class="fas fa-trash px-0"></i>
                </b-button>
              </template>
            </medhop-data-table>
            <medhop-pagination
              v-if="items.length != 0"
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              @page-click="pageOnClick"
              class="mt-4"></medhop-pagination>
          </template>
        </Card>
      </div>
    </div>
  </div>
</template>

<script>

import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Card from "@/view/content/Card.vue";
import { debouncer } from "@/core/modules/Helper.js"
import module from "@/core/modules/CrudModule.js";
import validation from "@/core/modules/ValidationModule.js";
import moment from "moment";

export default {
  name: "List",

  components: {
    Card,
  },

  data() {
    return {
      // Filter
      filter: {
        patient_name: "",
        start_date: "",
        end_date: "",
      },
      // Pagination
      perPage: 20,
      currentPage: 1,
      totalRows: 0,
      // Fields
      fields: [
        {
          key: "number",
          label: "#",
          sortable: true,
        },
        {
          key: "bed_id",
          label: "Kode Bed",
          sortable: true,
        },
        {
          key: "patient_nik",
          label: "NIK Pasien",
          sortable: true,
        },
        {
          key: "patient_name",
          label: "Pasien",
          sortable: true,
        },
        {
          key: "bed_name",
          label: "Bed",
          sortable: true,
        },
        {
          key: "allotedTime",
          label: "Tanggal Masuk",
          sortable: true,
        },
        {
          key: "dischargeTime",
          label: "Tanggal Keluar",
          sortable: true,
        },
        { key: "actions", label: "Aksi", tdClass: "width:30%" },
      ],
      items: [],
      manipulateBtn: false,
      usedBtn: false,
    };
  },

  methods: {
    pageOnClick(page) {
      this.currentPage = page;
      this.pagination();
    },

    async pagination() {
      let filterParams = `&patient_name=${this.filter.patient_name}&start_date=${this.filter.start_date}&end_date=${this.filter.end_date}`;
      let response = await module.paginate(
        "used-beds",
        `?page=${this.currentPage}&page_size=${this.perPage}${filterParams}`
      );
      let pagination = response.meta.pagination;
      this.totalRows = pagination.total;

      let a, b;
      b = this.perPage * (this.currentPage - 1) + 1;
      for (a = 0; a < response.data.length; a++) {
        response.data[a].number = b + a;
      }
      this.items = response.data;
    },

    handleDate(date) {
      return moment(date).format("DD-MM-YYYY");
    },

    filterByPatientName() {
      debouncer(() => {
        this.currentPage = 1;
        this.pagination();
      }, 500)
    },

    resetFilterPeriode() {
      this.filter = validation.clearForm(this.filter);
      this.pagination();
    },

    filterByPeriode() {
      this.currentPage = 1;
      this.pagination();
    },

    async handleEdit(id) {
      let data = await module.get("used-beds/" + id);
      data["_method"] = "put";
      data["is_used"] = 0;
      let response = await module.submit(data, "used-beds-delete/" + id);
      // Check Response
      if (response.state != "error") {
        // Success
        this.$root.$emit("UpdateNewAvailableBed");
        Swal.fire("Berhasil", "Berhasil Mengubah Status", "success");
        this.pagination();
      }
    },

    async handleDelete(id) {
      let result = await module.delete("used-beds/" + id);
      if (result) {
        this.pagination();
      }
    },

    // access management
    async setActiveMenu() {
      let access_right_user = window.localStorage.getItem(
        "access_right_display"
      );
      let access_right = JSON.parse(access_right_user);

      let a;
      for (a = 0; a < access_right.length; a++) {
        ;

        if (access_right[a] == "1302") {
          this.manipulateBtn = true;
        }
        if (access_right[a] == "1303") {
          this.usedBtn = true;
        }
      }
    },
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Bed" },
      { title: "Pemakaian" },
    ]);
    this.pagination();
    this.setActiveMenu();
  },
};
</script>

<style></style>
